import { connect } from 'react-redux';
import * as R from 'ramda';

import {
  fetchViewByList,
  getStoreValueByProp,
  getViewByListOptions,
  setAuthorizationBy,
  setDetailSearchTerm,
  setHasUnsavedChanges,
  setParams,
  setSelectStepSearchTerm,
  setWizardDetails,
} from '../../store/createNewCarrierAuthSlice';

import { getCurrentSelection } from '../../store/carrierAuthorizationsSlice';

import DetailStep from './Detail';

const mapState = R.applySpec({
  authorizationBy: getStoreValueByProp(['authorizationBy']),
  currentSelection: getCurrentSelection,
  detailSearchTerm: getStoreValueByProp(['detailSearchTerm']),
  hasUnsavedChanges: getStoreValueByProp(['hasUnsavedChanges']),
  params: getStoreValueByProp(['params']),
  supplier: getStoreValueByProp(['supplier']),
  viewByList: getStoreValueByProp(['viewByList']),
  viewByListOptions: getViewByListOptions,
});

const mapDispatchToProps = {
  fetchViewByList,
  setAuthorizationBy,
  setDetailSearchTerm,
  setHasUnsavedChanges,
  setParams,
  setSelectStepSearchTerm,
  setWizardDetails,
};

export default connect(mapState, mapDispatchToProps)(DetailStep);
